import React from 'react';
import { Field, useFormikContext } from 'formik';
import { Row, Col, Button, Form } from 'react-bootstrap';
import { ButtonTooltip, Icon, FormikInput } from '../../../components';
import { QuestionDescriptionFields, ScaleSelect } from './EvaluationScaleShared';
import { SEMANTIC_RANGE_OPTIONS, getRangeTicks, parseRange } from '../EvaluationScaleConfig';

export const SemanticDiffLayout = ({
  valuePath,
  questionChoicesAttributes = [],
  addSemanticRow,
  deleteSemanticRow
}) => {
  const { setFieldValue } = useFormikContext();

  const configIdx = questionChoicesAttributes.findIndex(c => c.kind === 'config');
  const range = questionChoicesAttributes[configIdx]?.label || '-3a3';
  const ticks = getRangeTicks(range);
  const { min, max } = parseRange(range);

  const leftChoices = questionChoicesAttributes.filter(c => c.kind === 'left' && !c._destroy);
  const rightChoices = questionChoicesAttributes.filter(c => c.kind === 'right' && !c._destroy);

  const handleRangeChange = val => {
    if (configIdx >= 0) {
      setFieldValue(`${valuePath}[questionChoicesAttributes][${configIdx}][label]`, val);
    }
  };

  return (
    <div className="mt-3">
      <QuestionDescriptionFields valuePath={valuePath} descriptionPlaceholder="Seleccione una opción" />
      <ScaleSelect label="Escala" options={SEMANTIC_RANGE_OPTIONS} value={range} onChange={handleRangeChange} />

      {leftChoices.map((leftChoice, rowIdx) => {
        const rightChoice = rightChoices.find(r => r.position === leftChoice.position);
        const leftRi = questionChoicesAttributes.indexOf(leftChoice);
        const rightRi = questionChoicesAttributes.indexOf(rightChoice);

        return (
          <div key={leftChoice.id || leftChoice.position} className="mb-3">
            <Row className="align-items-center mb-1">
              <Col xs="auto">
                <span className="eval-scale-row-label text-muted">Respuesta {rowIdx + 1}:</span>
              </Col>
              <Col xs="auto">
                <ButtonTooltip
                  variant="circle-danger"
                  className="btn-circle"
                  size="sm"
                  text="Eliminar fila"
                  onClick={() => deleteSemanticRow(leftChoice.position)}
                  disabled={leftChoices.length <= 1}
                >
                  <Icon icon="trash" />
                </ButtonTooltip>
              </Col>
            </Row>
            <div className="eval-semantic-row">
              <div className="eval-semantic-side">
                {leftRi >= 0 && (
                  <Field name={`${valuePath}[questionChoicesAttributes][${leftRi}][label]`}>
                    {({ field }) => (
                      <FormikInput
                        {...field}
                        value={field.value || ''}
                        maxLength={25}
                        placeholder="Extremo izquierdo"
                        customFormGroupClass="eval-semantic-label-input mb-0"
                      />
                    )}
                  </Field>
                )}
              </div>
              <div className="eval-semantic-scale-wrapper">
                <div className="eval-semantic-ticks">
                  {ticks.map(t => (
                    <span key={t}>{t}</span>
                  ))}
                </div>
                <Form.Control
                  type="range"
                  min={min}
                  max={max}
                  defaultValue={0}
                  step={1}
                  disabled
                  className="eval-semantic-slider"
                />
              </div>
              <div className="eval-semantic-side">
                {rightRi >= 0 && (
                  <Field name={`${valuePath}[questionChoicesAttributes][${rightRi}][label]`}>
                    {({ field }) => (
                      <FormikInput
                        {...field}
                        value={field.value || ''}
                        maxLength={25}
                        placeholder="Extremo derecho"
                        customFormGroupClass="eval-semantic-label-input mb-0"
                      />
                    )}
                  </Field>
                )}
              </div>
            </div>
          </div>
        );
      })}

      <Row className="mt-2">
        <Col className="d-flex justify-content-end">
          <Button variant="primary" size="sm" onClick={addSemanticRow}>
            Agregar Respuesta
          </Button>
        </Col>
      </Row>
    </div>
  );
};

export default SemanticDiffLayout;
